import { TOTAL_SUPPLY } from "./mint";
import { formatNumber } from "@/utils/string";

export const SHARE_TEXT = `Join the Whitelist Boxes now!\n\nFree-mint ${formatNumber(
  TOTAL_SUPPLY
)} boxes for the BOXES airdrop (30% supply).\nFree mint starts at 8:00 AM ET today, November 20.\n\nBOXES lists on Clanker at 8:15 AM ET from the creator wallet:\n0x763e3de344bba694fbb5e952910b8c60693b02f7 (Beware of fake tokens)`;

export const MINTED_SHARE_TEXT =
  "BOXES lists on Clanker at 8:00 AM ET from the creator wallet: 0x763e3de344bba694fbb5e952910b8c60693b02f7 (Beware of fake tokens)";

export const CHEST_SHARE_TEXT =
  "Open your mystery gift directly on the Miniapp — your $Kawaii reward is waiting.\n\nPlease note: $Kawaii will be listed at 8:00 AM ET on Nov 17.\nIt will be launched via Clanker, and we will publish the official contract address on Farcaster at that exact time. Do not interact with any fake or unofficial contracts.";
